import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type ModerationQueueQueryVariables = Types.Exact<{
  surface?: Types.InputMaybe<Types.ModerationSurface>
  statuses?: Types.InputMaybe<Array<Types.CommentStatus> | Types.CommentStatus>
  containerId?: Types.InputMaybe<Types.Scalars['ID']['input']>
  source?: Types.InputMaybe<Types.ModerationSource>
  category?: Types.InputMaybe<Types.ModerationCategory>
  minTopScore?: Types.InputMaybe<Types.Scalars['Float']['input']>
  authorUid?: Types.InputMaybe<Types.Scalars['Int']['input']>
  itemId?: Types.InputMaybe<Types.Scalars['ID']['input']>
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>
}>

export type ModerationQueueQuery = {
  __typename?: 'Query'
  moderationQueue: {
    __typename?: 'ModerationQueueConnection'
    total: number
    limit: number
    offset: number
    items: Array<{
      __typename?: 'ModerationQueueItem'
      itemId: string
      authorUid: number
      source?: Types.ModerationSource | null
      category?: Types.ModerationCategory | null
      topScore?: number | null
      reason?: string | null
      verdictStale?: boolean | null
      createdAt: any
      scores: Array<{
        __typename?: 'ModerationScore'
        category: Types.ModerationCategory
        score: number
      }>
      comment?: {
        __typename?: 'Comment'
        id?: string | null
        comment?: string | null
        subject?: string | null
        status?: Types.CommentStatus | null
        contentId?: number | null
        content?: Array<{
          __typename?: 'Content'
          id?: string | null
          contentId?: number | null
          contentType?: string | null
          title?: string | null
          path?: string | null
        } | null> | null
        userInfo?: { __typename?: 'UserInfoPublic'; uuid: string; username?: string | null } | null
      } | null
    }>
  }
}

export const ModerationQueueDocument = gql`
  query ModerationQueue(
    $surface: ModerationSurface = COMMENT
    $statuses: [CommentStatus!]
    $containerId: ID
    $source: ModerationSource
    $category: ModerationCategory
    $minTopScore: Float
    $authorUid: Int
    $itemId: ID
    $limit: Int = 50
    $offset: Int = 0
  ) {
    moderationQueue(
      surface: $surface
      statuses: $statuses
      containerId: $containerId
      source: $source
      category: $category
      minTopScore: $minTopScore
      authorUid: $authorUid
      itemId: $itemId
      limit: $limit
      offset: $offset
    ) {
      total
      limit
      offset
      items {
        itemId
        authorUid
        source
        category
        topScore
        reason
        verdictStale
        createdAt
        scores {
          category
          score
        }
        comment {
          id
          comment
          subject
          status
          contentId
          content {
            id
            contentId
            contentType
            title
            path
          }
          userInfo {
            uuid
            username
          }
        }
      }
    }
  }
`

/**
 * __useModerationQueueQuery__
 *
 * To run a query within a React component, call `useModerationQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useModerationQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModerationQueueQuery({
 *   variables: {
 *      surface: // value for 'surface'
 *      statuses: // value for 'statuses'
 *      containerId: // value for 'containerId'
 *      source: // value for 'source'
 *      category: // value for 'category'
 *      minTopScore: // value for 'minTopScore'
 *      authorUid: // value for 'authorUid'
 *      itemId: // value for 'itemId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useModerationQueueQuery(
  baseOptions?: Apollo.QueryHookOptions<ModerationQueueQuery, ModerationQueueQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ModerationQueueQuery, ModerationQueueQueryVariables>(
    ModerationQueueDocument,
    options,
  )
}
export function useModerationQueueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ModerationQueueQuery, ModerationQueueQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ModerationQueueQuery, ModerationQueueQueryVariables>(
    ModerationQueueDocument,
    options,
  )
}
// @ts-ignore
export function useModerationQueueSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ModerationQueueQuery,
    ModerationQueueQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ModerationQueueQuery, ModerationQueueQueryVariables>
export function useModerationQueueSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ModerationQueueQuery, ModerationQueueQueryVariables>,
): Apollo.UseSuspenseQueryResult<ModerationQueueQuery | undefined, ModerationQueueQueryVariables>
export function useModerationQueueSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ModerationQueueQuery, ModerationQueueQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ModerationQueueQuery, ModerationQueueQueryVariables>(
    ModerationQueueDocument,
    options,
  )
}
export type ModerationQueueQueryHookResult = ReturnType<typeof useModerationQueueQuery>
export type ModerationQueueLazyQueryHookResult = ReturnType<typeof useModerationQueueLazyQuery>
export type ModerationQueueSuspenseQueryHookResult = ReturnType<
  typeof useModerationQueueSuspenseQuery
>
export type ModerationQueueQueryResult = Apollo.QueryResult<
  ModerationQueueQuery,
  ModerationQueueQueryVariables
>
